var uris = [
  [1, require("/opt/buildhome/repo/js/features/invest/img/limitSellGraphics.png?asset")],
  [2, require("/opt/buildhome/repo/js/features/invest/img/limitSellGraphics@2x.png?asset")],
  [3, require("/opt/buildhome/repo/js/features/invest/img/limitSellGraphics@3x.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 343,
  height: 310,
  toString: function () {
    return this.uri;
  },
};
